import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { FormInput } from '../form-input/form-input.comp';
import { Text } from '../../new-libby';
import { DeprecatedHollowButton, DeprecatedButton } from '../../primitives/deprecated-buttons';
export var promptViewKey = 'prompt-view';
// tslint:disable-next-line:max-line-length
export var promptViewCreator = function (Comp) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                value: _this.props.initialValue
            };
            _this.changeValue = function (value) { return _this.setState({ value: value, validationError: undefined }); };
            _this.onEnter = function (e) {
                var _a = _this.props, onConfirm = _a.onConfirm, validator = _a.validator;
                var value = _this.state.value;
                if (validator) {
                    var validationError = validator(value);
                    if (validationError !== true) {
                        _this.setState({ validationError: validationError });
                        return;
                    }
                }
                return onConfirm(value, e);
            };
            return _this;
        }
        class_1.prototype.render = function () {
            var _a = this, props = _a.props, state = _a.state;
            // tslint:disable-next-line: max-line-length
            var cn = namespacedClassnames(promptViewKey, props.className, { unvalidated: !props.validator, invalid: !!state.validationError, 'with-borders': props.withBorders });
            return (React.createElement("div", { className: cn },
                React.createElement("header", null,
                    React.createElement(Text, { className: 'title', type: 'hsm', color: 't20' }, props.title),
                    React.createElement(Text, { type: 'hxs', color: 't30' }, props.subtitle)),
                React.createElement("main", null,
                    React.createElement(Comp, __assign({ className: 'value', value: state.value, onChange: this.changeValue, validationError: state.validationError }, props.additionalProps))),
                props.additionalAction && React.createElement("div", { className: 'additional-action-wrapper' }, props.additionalAction),
                React.createElement("footer", null,
                    React.createElement(DeprecatedHollowButton, { className: 'cancel', onClick: this.props.onCancel }, props.cancelText),
                    React.createElement(DeprecatedButton, { className: 'enter', disabled: !this.state.value ? props.disableConfirmWhileEmpty : undefined, onClick: this.onEnter }, props.confirmText))));
        };
        return class_1;
    }(React.PureComponent));
};
export var PromptView = promptViewCreator(FormInput);
//# sourceMappingURL=index.js.map